import React from 'react';

import { ProfAgentContext } from './AgentFavoritesProvider';

const noopAsync = async () => {};
const noop = () => {};

const noopContextValue = {
    agentData: {},
    customers: {},
    handleAddCustomer: noopAsync,
    handleOnChangeBusinessLike: noopAsync,
    handleAddCustomerToList: noop
};

export const NoopAgentFavoritesProvider: React.FC = ({ children }) => (
    <ProfAgentContext.Provider value={noopContextValue}>
        {children}
    </ProfAgentContext.Provider>
);
